import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldsInterventionsFuelConsumptionPerOperationReportComponent } from './fields-interventions-fuel-consumption-per-operation-report.component';
import {DxChartModule, DxPivotGridModule} from 'devextreme-angular';



@NgModule({
  declarations: [FieldsInterventionsFuelConsumptionPerOperationReportComponent],
  imports: [
    CommonModule,
    DxPivotGridModule,
    DxChartModule
  ],
  exports: [FieldsInterventionsFuelConsumptionPerOperationReportComponent]
})
export class FieldsInterventionsFuelConsumptionPerOperationReportModule { }
